import React, { useState } from 'react';

const JobContext = React.createContext(null);
export { JobContext };

const JobContextContainer = props => {
  const [editJobId, setEditJobId] = useState(0);
  const [driverList, setDriverList] = useState([]);
  const [activeDriverList, setActiveDriverList] = useState([]);
  const [incomingNumber, setIncomingNumber] = useState(null);
  const [outgoingCall, setOutgoingCall] = useState(null);
  const [noShowDialogInfo, setNoShowDialogInfo] = useState(null);
  const [cancelReasonInfo, setCancelReasonInfo] = useState(null);
  const [cancelJobInfo, setCancelJobInfo] = useState(null);
  const [exitJobEditing, setExitJobEditing] = useState(null);
  const [routePlanTempJobIds, setRoutePlanTempJobIds] = useState([]);
  const [routePlanData, setRoutePlanData] = useState({ jobs: [], vehicles: [] });
  const [routePlanModalOpen, setRoutePlanModalOpen] = useState(false);
  const [isRouteViewMode, setIsRouteViewMode] = useState(false);
  const [selectedRouteDriverId, setSelectedRouteDriverId] = useState(null);
  const [routeViewReservationDate, setRouteViewReservationDate] = useState(null);
  const [routeViewDriverSummaries, setRouteViewDriverSummaries] = useState([]);
  const [smartMatchSuggestions, setSmartMatchSuggestions] = useState([]);
  const [smartMatchModalInfo, setSmartMatchModalInfo] = useState(null);
  const [tripMonitorAlerts, setTripMonitorAlerts] = useState([]);
  const [tripMonitorModalInfo, setTripMonitorModalInfo] = useState(null);
  const [radiusApprovals, setRadiusApprovals] = useState([]);
  const [radiusApprovalModalInfo, setRadiusApprovalModalInfo] = useState(null);

  return (
    <JobContext.Provider
      value={{
        editJobId,
        setEditJobId,
        driverList,
        setDriverList,
        activeDriverList,
        setActiveDriverList,
        incomingNumber,
        setIncomingNumber,
        outgoingCall,
        setOutgoingCall,
        noShowDialogInfo,
        setNoShowDialogInfo,
        cancelJobInfo,
        setCancelJobInfo,
        cancelReasonInfo,
        setCancelReasonInfo,
        exitJobEditing,
        setExitJobEditing,
        routePlanData,
        setRoutePlanData,
        routePlanModalOpen,
        setRoutePlanModalOpen,
        routePlanTempJobIds,
        setRoutePlanTempJobIds,
        isRouteViewMode,
        setIsRouteViewMode,
        selectedRouteDriverId,
        setSelectedRouteDriverId,
        routeViewReservationDate,
        setRouteViewReservationDate,
        routeViewDriverSummaries,
        setRouteViewDriverSummaries,
        smartMatchSuggestions,
        setSmartMatchSuggestions,
        smartMatchModalInfo,
        setSmartMatchModalInfo,
        tripMonitorAlerts,
        setTripMonitorAlerts,
        tripMonitorModalInfo,
        setTripMonitorModalInfo,
        radiusApprovals,
        setRadiusApprovals,
        radiusApprovalModalInfo,
        setRadiusApprovalModalInfo,
      }}
    >
      {props.children}
    </JobContext.Provider>
  );
};

export default JobContextContainer;
